export default __webpack_public_path__ + "static/media/ic_cod.1afc72e1.svg";